import React, { Component } from 'react';
class Spinner extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

componentDidMount(){
// Ensure jQuery is loaded
if (!window.jQuery) {
  const jqueryScript = document.createElement('script');
  jqueryScript.src = 'https://code.jquery.com/jquery-3.4.1.min.js';
  jqueryScript.async = true;
  document.body.appendChild(jqueryScript);

  jqueryScript.onload = () => {
    this.loadOwlCarousel();
  };
} else {
  this.loadOwlCarousel();
}
}

loadOwlCarousel() {
// Dynamically load Owl Carousel script
const owlScript = document.createElement('script');
owlScript.src = './assets/lib/owlcarousel/owl.carousel.min.js'; // Relative to public folder
owlScript.async = true;
document.body.appendChild(owlScript);

owlScript.onload = () => {
  // Dynamically load main.js after Owl Carousel is ready
  const mainScript = document.createElement('script');
  mainScript.src = './assets/js/main.js';
  mainScript.async = true;
  document.body.appendChild(mainScript);

  mainScript.onload = () => {
    console.log('Owl Carousel and main.js loaded successfully');
  };
};
}




  render() {
    return (
        <div id="spinner" className="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center">
            <div className="spinner-border text-primary spinner-border-wh">
                <span className="sr-only">Loading...</span>
            </div>
        </div>

    );
  }
}

export default Spinner;
